/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable no-multi-str */
import React, { useEffect, useState } from "react"
import {
  Table,
  Tag,
  Pagination,
  Button,
  Select,
  Modal,
  Input,
} from "antd"
import styled from "styled-components"
import root from "window-or-global"
import { withRouter } from "react-router-dom"
import { ExclamationCircleOutlined } from "@ant-design/icons"
import { get, capitalize, throttle } from "lodash"
import RARTechContainer from "container/TechAssets"
import globalContainer from "container/BrokerDashboard/globalPagesContainer"
import UploadImageDrawer from "dumbComponents/BrokerDashboard/Components/UploadImageDrawer"
// import ConfirmationModal from "../../Common/ConfirmationModal"
import { serializer, handleDrawerActions } from "../../Common/Utils_listing.js"

const { confirm } = Modal

const StyledButton = styled.button`
  background: transparent;
  cursor: pointer;
  border: none;
  padding: 0px;
  text-align: left;
`
const ResultsFor = styled.p`
  font-size: 13px;
  font-weight: 400;
  line-height: 22px;
  -webkit-letter-spacing: 0em;
  -moz-letter-spacing: 0em;
  -ms-letter-spacing: 0em;
  letter-spacing: 0em;
  text-align: left;
  font-style: italic;
  color: #2d2d2d;
`

const Wrap = styled.div`
  padding-top: 17px;
  overflow-x: scroll;
  width: 100%;
  .infoTable {
    th, td {
      border-right: none;
      border-top: none;
      border-left: none;
      font-family: "Rubik", sans-serif;
    }

    th {
      padding: 5px 5px 5px 18px;
    }
    

    td {
      padding: 10px 5px 10px 18px;
      background: #fafafa;

      &:hover {
        background: #ffffff;
      }
     }
     tr {
      border-bottom: 1px solid black;
      cursor: pointer;
      &:hover {
        background:  #fafafa;
      }
    }
    .ant-table-thead tr th {
      border-bottom: 1px solid black;
      background: linear-gradient(0deg, #E5E5E5, #E5E5E5),
      linear-gradient(0deg, #E6E6E6, #E6E6E6);
    }
  }
`

const RFType = styled.div`
  display: inline-block;
  padding: 4px;
  font-size: 10px;
  background: #009688;
  color: #fff;
  border-radius: 4px;
  width: max-content;
  align-self: auto;
`
const UploadButton = styled.div`
  label {
    background-color: #27AE60;
    color: #fff;
    padding: 8px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 12px;

    ${props => props.isUploading && `
      background-color: #999;
    `}

  }
  input[type="file"] {
    display: none;
  } 
`
const CellDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  p {
    margin: 0px;
  }
`
const LightP = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0px;
`
const PAGE_SIZE = 10
//check here
const ResultsTable = (props) => {
  const {
    dealsListingResponse,
    fetchingList,
    deleteInvite,
    history,
    toggleDrawer,
    getConvertedOfferDealActionResponse,
    createContractActionResponse,
    getContractStatusResponse,
    toggleUploadImageDrawer,
    setDealIdToUpload,
    dealIdToUpload,
    getAllDealsListing,
    saveListingSteps,
    saveListingStepsResponse,
    setTotalListingCount,
    totalListingCount,
    updateSkyslopeEmailListing,
    updateSkyslopeEmailListingResponse,
  } = props || {}

  const [listingStatuses, setListingStatuses] = useState()
  const [showStatus, setShowStatus] = useState()
  const [isAddEmailModalVisible, setIsAddEmailModalVisible] = useState(false)
  const [newSkyslopeEmail, setNewSkyslopeEmail] = useState("")
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [emailError, setEmailError] = useState("")
  const [isEditMode, setIsEditMode] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)

  // Helper function to get saved filters from localStorage
  const getSavedFilters = () => {
    const savedFilters = localStorage.getItem('listingFilters');
    let filterParams = {};
    
    if (savedFilters) {
      try {
        const parsed = JSON.parse(savedFilters);
        // Convert dealType array to comma-separated string
        if (parsed.dealType && Array.isArray(parsed.dealType) && parsed.dealType.length > 0) {
          parsed.dealType = parsed.dealType.map(item => item.value || item).join(",");
        } else if (parsed.dealType && Array.isArray(parsed.dealType) && parsed.dealType.length === 0) {
          parsed.dealType = null;
        }
        filterParams = parsed;
      } catch (error) {
        console.error('Error parsing saved filters:', error);
      }
    }
    
    // If no saved filters, return empty object (no filters applied)
    return filterParams;
  }

  useEffect(() => {
    if (updateSkyslopeEmailListingResponse?.data) {
      // Refresh the listing data after successful email update
      // Reset to Page 1: Fetch 30 items
      setCurrentPage(1) // Reset to page 1
      getAllDealsListing({
        ...getSavedFilters(),
        type: "global",
        limit: 30, // Page 1 loads 30 items
        skip: 0,
        transactionType: "Listing",
      })
    }
  }, [updateSkyslopeEmailListingResponse?.data])

  useEffect(() => {
    setListingStatuses(getContractStatusResponse?.data && getContractStatusResponse?.data?.listingStatus && getContractStatusResponse?.data?.listingStatus?.length > 0 && getContractStatusResponse.data.listingStatus.map(x => (
      { label: x.display_name, value: x.value }
    )))
    
    // Initial load: Fetch 30 items (Page 1)
    setCurrentPage(1) // Set initial page to 1
    getAllDealsListing({
      ...getSavedFilters(),
      type: "global",
      limit: 30, // Page 1 loads 30 items
      skip: 0,
      transactionType: "Listing",
    })
  }, [getContractStatusResponse?.data])
  //console.log("listingStatus", listingStatuses)
  const { isFetching, data: listingData, isFetchingMore } = dealsListingResponse

  const redirect = (record) => {
    if (record.activeContractId !== null) {
      root.open(`/broker/dashboard/${record.agentId}/deals/view/${record.activeContractId}?fromContract?listingId=${record.dealId}`)
    } else {
      root.open(`/broker/dashboard/${record.agentId}/deals/view/${record.dealId}?fromListing?listingId=${record.dealId}`)
    }
  }

  const handleStatusUpdate = (data, value) => {
    if (value === "pending") {
      const isActive = window.confirm("Since you are changing the status of a New Listing to 'Pending', we will be creating a Contract and Changing Contract status to Incomplete. Please fill the  pending Transaction Details for this Contract to change status of contract from Incomplete to Submitted")
      if (!isActive) {
        return
      }
    } else {
      const isConfirm = window.confirm("Are you sure?")
      if (!isConfirm) {
        return
      }
    }
    const payload = {
      listing_id: data.dealId,
      step: value,
      notes: "",
    }
    saveListingSteps({
      payload,
      callback: () => {
        getAllDealsListing({
          type: "global",
          limit: 30,
          skip: 0,
          transactionType: "Listing",
        })
      },
    })
    setShowStatus(value)
  }

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!email) {
      return "Email is required"
    }
    if (!emailRegex.test(email)) {
      return "Please enter a valid email address"
    }
    return ""
  }

  const handleEmailChange = (e) => {
    const email = e.target.value
    setNewSkyslopeEmail(email)
    const error = validateEmail(email)
    setEmailError(error)
  }

  const handleAddEmailClick = (record) => {
    console.log("handleAddEmailClick called with record:", record)
    setSelectedRecord(record)
    setIsAddEmailModalVisible(true)
    setNewSkyslopeEmail("")
    setEmailError("")
    setIsEditMode(false)
    console.log("Modal should be visible now", isAddEmailModalVisible)
  }

  const handleEditEmailClick = (record) => {
    console.log("handleEditEmailClick called with record:", record)
    setSelectedRecord(record)
    setIsAddEmailModalVisible(true)
    setNewSkyslopeEmail(record.skyslopeEmail || "")
    setEmailError("")
    setIsEditMode(true)
    console.log("Edit modal should be visible now", isAddEmailModalVisible)
  }

  const handleDeleteEmailClick = (record) => {
    Modal.confirm({
      title: 'Delete Skyslope Email',
      content: 'Are you sure you want to delete this Skyslope email? This action cannot be undone.',
      okText: 'Yes, Delete',
      cancelText: 'Cancel',
      okType: 'danger',
      onOk() {
        const payload = {
          listing_id: record.dealId,
          skyslope_email: "",
        }
        
        updateSkyslopeEmailListing(payload)
      },
    })
  }

  const handleEmailModalCancel = () => {
    setIsAddEmailModalVisible(false)
    setNewSkyslopeEmail("")
    setSelectedRecord(null)
    setEmailError("")
    setIsEditMode(false)
  }

  const handleEmailSubmit = () => {
    const error = validateEmail(newSkyslopeEmail)
    if (error) {
      setEmailError(error)
      return
    }

    if (newSkyslopeEmail && selectedRecord) {
      const payload = {
        listing_id: selectedRecord.dealId,
        skyslope_email: newSkyslopeEmail,
      }
      
      updateSkyslopeEmailListing(
        payload
      )
    }
  }

  useEffect(() => {
    if (updateSkyslopeEmailListingResponse?.data) {
               setIsAddEmailModalVisible(false)
          setNewSkyslopeEmail("")
          setSelectedRecord(null)
          setEmailError("")
          setIsEditMode(false)
      getAllDealsListing({
        type: "global",
        limit: PAGE_SIZE,
        skip: 0,
        transactionType: "Listing",
      })
    }
  }, [updateSkyslopeEmailListingResponse])  
  
    useEffect(() => {
    if (updateSkyslopeEmailListingResponse?.isError) {
             setIsAddEmailModalVisible(false)
          setNewSkyslopeEmail("")
          setSelectedRecord(null)
      setEmailError("")
      setIsEditMode(false)
      getAllDealsListing({
        type: "global",
        limit: PAGE_SIZE,
        skip: 0,
        transactionType: "Listing",
      })
    }
    }, [updateSkyslopeEmailListingResponse])
  
  const createColumn = () => {
    const columns = [
      {
        title: "Actions",
        dataIndex: "actions",
        render: (text, record) => (
          <>
            <Select
              options={listingStatuses}
              openMenuOnClick={(e) => { e.preventDefault() }}
              value={record.listingStatus}
              style={{
                width: 200,
              }}
              onChange={(selectedItem) => { handleStatusUpdate(record, selectedItem) }}
              // loading={isFetchingStatus}
              // disabled={record.listingStatus === "incomplete"}
            />
          </>
        ),
      },
      {
        title: "Date of Listing Submission",
        dataIndex: "dateOfListingSubmission",
        key: "dateOfListingSubmission",
        onCell: record => ({ onClick: () => { redirect(record) } }),
      },
      {
        title: "Agent Name",
        dataIndex: "agentName",
        key: "agentName",
        onCell: record => ({ onClick: () => { redirect(record) } }),
      },
      {
        title: "Preferred Email",
        dataIndex: "preferredEmail",
        key: "preferredEmail",
        onCell: record => ({ onClick: () => { redirect(record) } }),
      },
      {
        title: "Skyslope email",
        dataIndex: "skyslopeEmail",
        key: "skyslopeEmail",
        onCell: record => record.skyslopeEmail ? ({ onClick: () => { redirect(record) } }) : {},
        render: (text, record) => (
          <>
            {record.skyslopeEmail ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <span>{record.skyslopeEmail}</span>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <Button
                    type="primary"
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation()
                      handleEditEmailClick(record)
                    }}
                    style={{ width: 'fit-content' }}
                  >
                    Edit email
                  </Button>
                  <Button
                    type="default"
                    size="small"
                    danger
                    onClick={(e) => {
                      e.stopPropagation()
                      handleDeleteEmailClick(record)
                    }}
                    style={{ width: 'fit-content' }}
                  >
                    Delete email
                  </Button>
                </div>
              </div>
            ) : (
              <Button
                type="primary"
                size="small"
                onClick={(e) => {
                  e.stopPropagation()
                  handleAddEmailClick(record)
                }}
              >
                Add email
              </Button>
            )}
          </>
        ),
      },
      {
        title: "Address",
        dataIndex: "propertyAddress",
        key: "propertyAddress",
        onCell: record => ({ onClick: () => { redirect(record) } }),
      },
      {
        title: "Client Details",
        dataIndex: "clientType",
        key: "clientType",
        onCell: record => ({ onClick: () => { redirect(record) } }),
        render: (text, record) => (
          <CellDiv>
            <p>{get(record, "clientDetails.client_name", "") || "-"}</p>
            <LightP>
              {`${get(record, "clientDetails.client_email", "") || ""}`}
            </LightP>
            <LightP>
              {`${get(record, "clientDetails.client_phone", "") || ""}`}
            </LightP>
            {get(record, "numOfClients") > 1 && (
              <div style={{ fontSize: 12, fontWeight: "700" }}>
                {get(record, "numOfClients") - 1}
                {" "}
                more clients
              </div>
            )}
            <RFType>
              {capitalize(record.clientType)}
            </RFType>
          </CellDiv>
        ),
      },
      {
        title: "Upload Image",
        dataIndex: "uploadImage",
        render: (text, record) => (
          <>
            <Button
              onClick={() => {
                toggleUploadImageDrawer(true)
                setDealIdToUpload(record.dealId)
              }}
              type="primary"
            >
              {record.listingImages !== null ? "View Images" : "Upload Images"}
            </Button>
          </>
        ),
      },
      {
        title: "Cap Amount",
        dataIndex: "capAmount",
        key: "capAmount",
        onCell: record => ({ onClick: () => { redirect(record) } }),
      },
      {
        title: "List Price",
        dataIndex: "listPrice",
        key: "listPrice",
        onCell: record => ({ onClick: () => { redirect(record) } }),
      },
      {
        title: "Active Contract",
        dataIndex: "activeContractId",
        render: (text, record) => (
          <>
            {record.activeContractId ? (
              <Button
                type="primary"
                onClick={() => {
                  root.open(`/broker/dashboard/${record.agentId}/deals/view/${record.activeContractId}`)
                }}
              >
            View Contract
              </Button>
            ) : "-"}
          </>
        ),
      },
    ]
    return columns
  }

  const serialized = !isFetching && serializer(listingData) || []
  const { isFetching: isFetchingStatus } = saveListingStepsResponse

  useEffect(() => {
    setShowStatus(serialized.listingStatus)
  }, [serialized])

  const {
    isFetching: gettingDealId,
  } = getConvertedOfferDealActionResponse || {}

  const {
    isFetching: convertingToContract,
  } = createContractActionResponse || {}

  const onChange = (page, pageSize) => {
    console.log("Page changed to:", page, "Page size:", pageSize)
    
    // Update current page state
    setCurrentPage(page)
    
    let skip, limit;
    
    if (page === 1) {
      // Page 1: Fetch 30 items starting from 0
      skip = 0;
      limit = 30;
    } else {
      // Other pages: Fetch 10 items each
      // Page 2: skip 30, limit 10
      // Page 3: skip 40, limit 10
      // Page 4: skip 50, limit 10
      skip = 30 + (page - 2) * 10;
      limit = 10;
    }
    
    console.log("Fetching with skip:", skip, "limit:", limit)
    
    getAllDealsListing({
      ...getSavedFilters(),
      type: "global",
      limit: limit,
      skip: skip,
      transactionType: "Listing",
    })
  }
  return (
    <Wrap>
      <Table
        className="infoTable"
        columns={createColumn()}
        dataSource={serialized}
        loading={isFetching || gettingDealId || convertingToContract}
        scroll={{
          x: 2000,
        }}
        pagination={
          {
            total: totalListingCount,
            pageSize: 10, // Display 10 items per page in UI
            current: currentPage, // Use the current page state
            showSizeChanger: false,
            showQuickJumper: true,
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
            onChange,
          }
        }
      >
      </Table>
      <UploadImageDrawer dealId={dealIdToUpload} data={listingData} />
      
      <Modal
        title={isEditMode ? "Edit Skyslope Email" : "Add Skyslope Email"}
        visible={isAddEmailModalVisible}
        onCancel={handleEmailModalCancel}
        footer={[
          <Button key="cancel" onClick={handleEmailModalCancel}>
            Cancel
          </Button>,
          <Button 
            key="submit" 
            type="primary" 
            onClick={handleEmailSubmit}
            disabled={!newSkyslopeEmail.trim() || emailError || updateSkyslopeEmailListingResponse?.isFetching}
            loading={updateSkyslopeEmailListingResponse?.isFetching}
          >
            {isEditMode ? "Update Email" : "Add Email"}
          </Button>,
        ]}
        width={500}
      >
        <div style={{ marginBottom: 16 }}>
          <p style={{ color: '#666', marginBottom: 16 }}>
            {isEditMode ? "Update the Skyslope email address for this listing." : "Enter the Skyslope email address for this listing."}
          </p>
          <div style={{ marginBottom: 8 }}>
            <label style={{ fontWeight: 'bold', marginBottom: 8, display: 'block' }}>
              Skyslope Email Address
            </label>
            <Input
              placeholder="Enter Skyslope email address"
              value={newSkyslopeEmail}
              onChange={handleEmailChange}
              onPressEnter={handleEmailSubmit}
              style={{ width: '100%' }}
              status={emailError ? 'error' : ''}
            />
            {emailError && (
              <div style={{ color: '#ff4d4f', fontSize: '12px', marginTop: '4px' }}>
                {emailError}
              </div>
            )}
          </div>
        </div>
      </Modal>
    </Wrap>
  )
}

export default globalContainer(withRouter(RARTechContainer(ResultsTable)))
